import type { ProjectAccessMap, ProjectRole } from '@xver/apis/v1/projects/model';
import { formatDateTime } from '@xver/utils/date';
import { PROJECT_PRODUCTS } from '@xver/utils/projects';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export const PRODUCTS = PROJECT_PRODUCTS;

/** Small outlined text badge; meaning is always in the text, never the color. */
export function TextBadge({ children }: { children: ReactNode }) {
    return (
        <span className="inline-flex items-center shrink-0 px-1.5 rounded-sm border-[0.5px] border-line text-xs font-medium text-fg/78">
            {children}
        </span>
    );
}

/** "VMs: Manage · Bare metal: View · Containers: No access"; owner and admin read "Full access". */
export function AccessSummary({ role, access }: { role: ProjectRole; access: ProjectAccessMap }) {
    const { t } = useTranslation('projects');
    if (role !== 'member') return <>{t('access.full')}</>;
    return (
        <>
            {PRODUCTS.map(
                (product) =>
                    `${t(`products.${product}`)}: ${t(`access.levels.${access[product] ?? 'none'}`)}`
            ).join(' · ')}
        </>
    );
}

/** `<time>` showing an absolute date and time in the UI language. */
export function DateTime({ iso }: { iso: string }) {
    const { i18n } = useTranslation();
    return <time dateTime={iso}>{formatDateTime(iso, i18n.language)}</time>;
}
